import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { FixedTitle } from '@tphglobal/common/utils';
import { Grid } from '@mui/material';

const PrivacyNotice: React.FC = () => {
  return (
    <Grid container justifyContent='center' pb={3} px={5}>
      <FixedTitle varient='Fixed14Medium' component={'div'} textAlign='justify'>
        <span>
          We are committed to protecting your privacy and handling your personal
          information in accordance with applicable Privacy Laws. When you use
          our Platforms, we collect personal information necessary to provide
          payroll and related services to our Clients and their Users.
        </span>
        <p>
          Please do not upload or submit sensitive information unless explicitly
          requested and securely facilitated by our Platform, such as:
        </p>
        <List
          sx={{
            listStyleType: 'disc',
            textAlign: 'justify',
            pl: 3,
            '& .MuiListItem-root': {
              display: 'list-item',
              textAlign: 'justify',
            },
            paddingTop: '0',
          }}
        >
          <ListItem>
            Health information (e.g. medical records or certificates)
          </ListItem>
          <ListItem>Racial or ethnic origin</ListItem>
          <ListItem>Religious or philosophical beliefs</ListItem>
          <ListItem>Sexual orientation or practices</ListItem>
          <ListItem>Criminal history</ListItem>
          <ListItem>Biometric or genetic data</ListItem>
          <ListItem>Trade union membership</ListItem>
        </List>
        <span>
          If you believe you have inadvertently submitted sensitive information,
          please contact our support team immediately so we can assist with
          secure handling or removal. For more information about how we manage
          your personal information, please refer to our Privacy Policy.
        </span>
      </FixedTitle>
    </Grid>
  );
};

export default PrivacyNotice;
